import { useMutation } from "react-query";
import downloadInvoice from "../services/downloadInvoice";

function useDownloadInvoice() {
  return useMutation(["download-invoice"], downloadInvoice);
}

export default useDownloadInvoice;
